import './MachineStatus.scss'
import { format } from "date-fns"
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import { MachineStatus as MachineStatusClass, statusCodes } from '../../utils/models/MachineStatus';
import { useEffect, useState } from 'react';
import { Machine } from '../../utils/models/Machine';
import { getAllCompanyStates } from '../../utils/services/company.service';
import { Company } from '../../utils/models/Company';
import { getAllInstalationStates } from '../../utils/services/instalation.service';
import { Instalation } from '../../utils/models/Instalation';
import { getAllMachineStates } from '../../utils/services/machine.service';
import { DashboardTypes } from 'aw-consts';
import { getRandomNumber } from 'aw-generic-functions';
import { ReactComponent as NoInfoIcon } from '../../utils/resources/icons/NoInfo.svg'

export interface IMachineStatus {
    machineName?: string;
    instalation?: string;
    date: Date;
    msg: string;
    alertType: number;
    prodDelivery: boolean;
    solved: boolean
    idstate: number
}

const MachineStatus = (props: { id: number, title: string, dashboardType: number, user: any, refresh: boolean, iniDate: string, finDate: string, token: string, updLastConnection: (lastConnection: Date) => void }) => {
  const [machineStatus, setMachineStatus] = useState<IMachineStatus[]>([])
  const { t } = useTranslation()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (props.refresh && props.id && props.id > 0) {
      setLoading(true)
      if (props.dashboardType === DashboardTypes.Machine) {
        getAllMachineStates(props.token, props.id, props.iniDate, props.finDate)
          .then((m: Machine) => {
            props.updLastConnection(m.last_conection)
            const machineStatesArray: IMachineStatus[] = []
            m.machine_status.forEach((ms: MachineStatusClass) => {
              let msgAux = ""
                            let prodDelivery = false
              if (ms.cod_status === statusCodes.Notification) {
                msgAux = `${ms.notification_desc}`
              }
              machineStatesArray.push({
                machineName: ``,
                date: ms.createdAt,
                msg: msgAux,
                alertType: ms.cod_status,
                prodDelivery: prodDelivery,
                solved: ms.solved,
                                idstate: ms.idstatus
              })
            })
            machineStatesArray.sort((a: IMachineStatus, b: IMachineStatus) => {
              return new Date(b.date).getTime() - new Date(a.date).getTime()
            })
            setMachineStatus(machineStatesArray)
          })
          .catch((e) => {
            console.log("getAllMachineStates", e)
          })
          .finally(() => {
            setTimeout(() => {
              setLoading(false)
            }, 500)
          })
      } else if (props.dashboardType === DashboardTypes.MachineGroup) {
        getAllInstalationStates(props.token, props.id, props.iniDate, props.finDate)
          .then((c: Instalation) => {
            const machineStatesArray: IMachineStatus[] = []
            if (c.machines && c.machines.length > 0) {
              c.machines.forEach((m: Machine) => {
                m.machine_status.forEach((ms: MachineStatusClass) => {
                  let msgAux = ""
                                    let prodDelivery = false
                  if (ms.cod_status === statusCodes.Notification) {
                    msgAux = `${ms.notification_desc}`
                  }
                  machineStatesArray.push({
                    machineName: `${m.name}`,
                    //instalation: c.name,
                    date: ms.createdAt,
                    msg: msgAux,
                    alertType: ms.cod_status,
                    prodDelivery: prodDelivery,
                    solved: ms.solved,
                    idstate: ms.idstatus
                  })
                })
              })
            }
            machineStatesArray.sort((a: IMachineStatus, b: IMachineStatus) => {
              return new Date(b.date).getTime() - new Date(a.date).getTime()
            })
            setMachineStatus(machineStatesArray)
          })
          .catch((e) => {
            console.log("getAllContainerStates", e)
          })
          .finally(() => {
            setTimeout(() => {
              setLoading(false)
            }, 500)
          })
      } else if (props.dashboardType === DashboardTypes.Company) {
        getAllCompanyStates(props.token, props.id, props.iniDate, props.finDate)
          .then((co: Company) => {
            const machineStatesArray: IMachineStatus[] = []
            if (co.instalations && co.instalations.length > 0) {
              co.instalations.forEach((c: Instalation) => {
                if (c.machines && c.machines.length > 0) {
                  c.machines.forEach((m: Machine) => {
                    m.machine_status.forEach((ms: MachineStatusClass) => {
                      let msgAux = ""
                                            let prodDelivery = false
                      if (ms.cod_status === statusCodes.Notification) {
                        msgAux = `${ms.notification_desc}`
                      }
                      machineStatesArray.push({
                        machineName: `${m.name}`,
                        instalation: c.name,
                        date: ms.createdAt,
                        msg: msgAux,
                        alertType: ms.cod_status,
                        prodDelivery: prodDelivery,
                        solved: ms.solved,
                        idstate: ms.idstatus
                      })
                    })
                  })
                }
              })
            }
            machineStatesArray.sort((a: IMachineStatus, b: IMachineStatus) => {
              return new Date(b.date).getTime() - new Date(a.date).getTime()
            })
            setMachineStatus(machineStatesArray)
          })
          .catch((e) => {
            console.log("getAllCompanyStates", e)
          })
          .finally(() => {
            setTimeout(() => {
              setLoading(false)
            }, 500)
          })
      } else {
        setLoading(false)
      }
    } else {
      setLoading(false)
    }
  }, [props.id, props.refresh])



  const alertType = (type: number, prodDelivery: boolean, solved: boolean) => {
    let colorAlarm: string
    switch (type) {
      case statusCodes.Action:
                colorAlarm = 'bgprimary rounded'
                break;
      case statusCodes.Available:
                colorAlarm = 'bgsuccess rounded'
                break;
      case statusCodes.Notification:
                colorAlarm = solved ? 'bgsecondary rounded' : 'bgwarning rounded'
                break;
      case statusCodes.Ping:
                colorAlarm = 'bgsecondary rounded'
                break;
      case statusCodes.OutOfService:
                colorAlarm = 'bgsecondary rounded'
                break;
      default:
                colorAlarm = 'bgsecondary rounded'
                break;
    }
    return colorAlarm
  }

  const alertMsg = (type: number, msg: string) => {
    let msgAlarm: string
    switch (type) {
      case statusCodes.Action:
                msgAlarm = msg !== '' ? msg : t('Working')
                break;
      case statusCodes.Available:
                msgAlarm = t('Available')
                break;
      case statusCodes.Notification:
        msgAlarm = t(`Alert${getRandomNumber(1, 5)}`)
        break
      case statusCodes.Ping:
                msgAlarm = 'Ping'
                break;
      case statusCodes.OutOfService:
                msgAlarm = t('OutOfService')
                break;
      default:
                msgAlarm = ''
                break;
    }
    return msgAlarm
  }

  const alertIcon = (type: number) => {
    const iconStyle = { lineHeight: 1, transform: "translateY(-1px)" }

    switch (type) {
      case statusCodes.Action:
        return <i className="bi bi-fan fs-1" style={iconStyle} />
      case statusCodes.Available:
        return <i className="bi bi-info-lg fs-1" style={iconStyle} />
      case statusCodes.Ping:
        return <i className="bi bi-activity fs-1" style={iconStyle} />
      case statusCodes.Notification:
        return (
          <div>
            <i className="bi bi-exclamation-lg fs-1" style={iconStyle} />
          </div>
        )
      case statusCodes.OutOfService:
        return <i className="bi bi-wrench h2" style={iconStyle} />
      default:
        return <i className="bi bi-info-lg fs-1" style={iconStyle} />
    }
  }

  return (
    <div className="pt-2 text-center rounded-1" id="machineStatusContainer">
      <span className="mt-1 h4">{props.title}</span>
      {loading ? (
        <div className="pt-5">
          <Spinner animation="border" variant="success" />
        </div>
      ) : (
        <div className="scrollable-div">
          {machineStatus && machineStatus.length > 0 ? (
            machineStatus.map((m, i) => (
              <div key={i} className="mb-2 me-0 text-start d-flex align-items-center status-card">
                <div className="d-flex align-items-center">
                  <div
                    className={`circle-50 align-items-center justify-content-center d-flex ${alertType(m.alertType, m.prodDelivery, m.solved)} text-black`}
                  >
                    <div>{alertIcon(m.alertType)}</div>
                  </div>
                </div>
                <div className="ms-2 d-flex flex-column justify-content-center" style={{margin:'4'}}>
                  <p className="h5 mb-0" style={{margin:'10'}}>{alertMsg(m.alertType, m.msg)}</p>

                  {m.machineName !== "" && <p className="mb-0">{format(new Date(m.date), "dd/MM/yyyy HH:mm:ss")}</p>}
                </div>
                <div className="ms-auto d-flex flex-column justify-content-center">
                  <div className="text-end p-0 me-2"> {m.instalation} </div>
                  {m.machineName !== "" ? (
                    <div className={`ms-auto p-1 me-2 ${alertType(m.alertType, m.prodDelivery, m.solved)} text-black`}>
                      <p className="m-0">{m.machineName}</p>
                    </div>
                  ) : (
                    <p className="mb-0 me-1 text-end ps-2">{format(new Date(m.date), "dd/MM/yyyy HH:mm:ss")}</p>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p>{props.dashboardType === DashboardTypes.Machine ? t("NoStates2Info") : t("NoStatesInfo")}</p>
          )}
        </div>
      )}
    </div>
  )
}

export default MachineStatus
